jQuery(function($) {
    'use strict';

    var AppCountdown = function() {
        this.html_inline = '<span>##days##</span><small>D</small> <span>##hours##</span><small>H</small> <span>##minutes##</span><small>M</small> <span>##seconds##</span><small>S</small>';
        this.html_block = '<div class="countdown-number"><span>##days##</span>Tage</div><div class="countdown-number"><span>##hours##</span>Stunden</div><div class="countdown-number"><span>##minutes##</span>Minuten</div><div class="countdown-number"><span>##seconds##</span>Sekunden</div>';
        this.spinner = '<i class="fa-regular fa-circle-notch fa-spin fa-fw"></i>';
    }

    AppCountdown.prototype.init = function() {
        $('[data-countdown]').each(function() {
            var date = $(this).data('countdown-date');
            var layout = $(this).data('countdown-layout') ?? 'inline';

            $.AppCountdown.load($(this), date, layout);
        });
    }

    AppCountdown.prototype.load = function(wrapper, date, layout = 'inline') {
        var countDownDate = new Date(date).getTime();
        var now = new Date().getTime();

        var html = $.AppCountdown.html_inline;
        if(layout == 'block') {
            html = $.AppCountdown.html_block;
        }

        if(countDownDate - now > 0) {
            wrapper.html(html.replace('##days##', $.AppCountdown.spinner).replace('##hours##', $.AppCountdown.spinner).replace('##minutes##', $.AppCountdown.spinner).replace('##seconds##', $.AppCountdown.spinner));

            var countDownInterval = setInterval(function() {
                var now = new Date().getTime();
                var distance = countDownDate - now;

                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                // days = ('0'+days).substr(String('0'+days).length-2);
                hours = ('0'+hours).substr(String('0'+hours).length-2);
                minutes = ('0'+minutes).substr(String('0'+minutes).length-2);
                seconds = ('0'+seconds).substr(String('0'+seconds).length-2);

                if(distance < 0) {
                    clearInterval(countDownInterval);

                    wrapper.html('');
                } else {
                    wrapper.removeClass('prepare').html(html.replace('##days##', days).replace('##hours##', hours).replace('##minutes##', minutes).replace('##seconds##', seconds));
                }
            }, 1000);
        }
    }

    $.AppCountdown = new AppCountdown;
    $.AppCountdown.Constructor = AppCountdown;
});

jQuery(function($) {
    'use strict';

    $.AppCountdown.init();
});
